import { useState } from "react";
import "./index.css";

import { LabelView } from "./LabelView";
import { StickerView } from "./StickerView";
import { ArtworkView } from "./ArtworkView";
import { Button } from "@/components/ui/button";

type Mode = "label" | "stickers" | "artwork";

export function App() {
  const [mode, setMode] = useState<Mode>("label");

  return (
    <div className="h-screen flex flex-col min-h-0">
      <header className="border-b px-6 py-3 flex items-center gap-4">
        <h1 className="text-lg font-bold tracking-tight">tixpix</h1>
        <nav className="flex items-center gap-1">
          <Tab current={mode} value="label" onClick={setMode}>
            Label
          </Tab>
          <Tab current={mode} value="stickers" onClick={setMode}>
            Stickers
          </Tab>
          <Tab current={mode} value="artwork" onClick={setMode}>
            Artwork
          </Tab>
        </nav>
      </header>

      {mode === "label" ? <LabelView /> : mode === "stickers" ? <StickerView /> : <ArtworkView />}
    </div>
  );
}

function Tab({
  current,
  value,
  onClick,
  children,
}: {
  current: Mode;
  value: Mode;
  onClick: (m: Mode) => void;
  children: React.ReactNode;
}) {
  return (
    <Button
      variant={current === value ? "secondary" : "ghost"}
      size="sm"
      onClick={() => onClick(value)}
    >
      {children}
    </Button>
  );
}

export default App;
